import './App.css';
import Invoice from './components/Invoice';

function App() {
  return (
    <div className="App">
      <Invoice />
    </div>
  );
}

export default App;
